
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.13156',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13156",
  "apollo-dlb": "static-3.86",
  "breeze-builder-lib": "static-1.653",
  "client-types": "static-1.494",
  "data-fetching-client": "static-1.9920",
  "foundations-components": "static-1.8422",
  "foundations-components-legacy": "static-1.1447",
  "foundations-theming": "static-1.4730",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.86",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8291",
  "hub-http-shared-msw-handlers": "static-1.10552",
  "hubspot-dlb": "static-2.1882",
  "hubspot-url-utils": "static-1.4297",
  "HubStyleTokens": "static-2.11746",
  "I18n": "static-7.1665",
  "jasmine-runner": "static-1.6715",
  "marketplace-discovery-studio-lib": "static-1.575",
  "marketplace-storefront-base": "static-1.13219",
  "quartz": "static-1.7399",
  "react-dlb": "static-1.87",
  "react-rhumb": "static-1.16974",
  "reactive-variable-buffer-atom": "static-1.3118",
  "reporting-testing-lib": "static-1.10592",
  "reselect": "static-3.9",
  "settings-ui-lib": "static-1.12783",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7580",
  "ui-addon-i18n": "static-1.11406",
  "ui-addon-react-router-dom": "static-1.9800",
  "unified-auth": "static-1.836",
  "unified-auth-core-lib": "static-1.1118",
  "usage-tracker": "static-1.7619",
  "usage-tracker-core": "static-1.7469",
  "customer-data-property-utils": "static-1.8361",
  "hub-http": "static-1.6476",
  "integrations-lib": "static-1.16960",
  "marketplace-ui-common": "static-1.20636",
  "marketplace-ui-install": "static-1.622",
  "property-management-iframe": "static-1.14045",
  "quartz-config": "static-1.1177",
  "quartz-core": "static-1.6618",
  "quartz-routing": "static-1.829",
  "quick-fetch": "static-1.4106",
  "react": "static-7.191",
  "rpc-client-utils": "static-1.4925",
  "ts-schema": "static-1.4269",
  "ui-universal-auth": "static-1.9322",
  "UIComponents": "static-3.8692",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.83",
  "metrics-js": "static-1.9867",
  "react-redux": "static-7.75",
  "redux": "static-4.76",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3591",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3676",
  "quartz-webpack": "static-1.3623",
  "bend-plugin-quartz-routing": "static-1.477",
  "ai-components-ui-library": "static-1.9630",
  "codemirror": "static-5.99",
  "foundations-assets": "static-1.5146",
  "pulse": "static-1.887",
  "react-codemirror": "static-1.10901",
  "ui-extensions-preview-lib": "static-1.521",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4691",
  "floating-ui": "static-1.62",
  "foundations-theming-specialty": "static-1.2446",
  "framer-motion": "static-1.76",
  "hs-story-utils": "static-1.9689",
  "react-aria": "static-1.70",
  "react-create-root-preference": "static-1.64",
  "react-select-plus": "static-1.109",
  "react-utils": "static-2.5529",
  "react-virtualized": "static-2.104",
  "StyleGuideUI": "static-3.497",
  "tanstack-table": "static-1.59",
  "trellis-assets": "static-1.2527",
  "ui-fonts": "static-1.1008",
  "ui-images": "static-2.1234",
  "bend-plugin-foundations-theming": "static-1.3213",
  "foundations-theming-base": "static-1.3715",
  "stylex": "static-1.38",
  "HeadJS": "static-2.791",
  "hs-test-utils-bend-plugin": "static-1.3402",
  "msw": "static-1.39",
  "testing-library": "static-1.156",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.228",
  "moment-timezone": "static-5.87",
  "jasmine": "static-4.4578",
  "ui-addon-video-player": "static-1.8965",
  "ai-rendering-library": "static-1.11030",
  "chirp-fetch": "static-1.2156",
  "connections-embed-lib": "static-1.1457",
  "copilot-toolkit": "static-1.11776",
  "feedback-loader": "static-1.29755",
  "laboratory-lib": "static-3.7414",
  "marketplace-embed": "static-1.22846",
  "marketplace-ui-details": "static-1.10531",
  "marketplace-ui-reviews": "static-1.20591",
  "marketplace-ui-tracking": "static-1.14806",
  "sanitize-text": "static-1.8414",
  "usage-tracker-multi": "static-1.6033",
  "usage-tracker-session-replay": "static-1.5305",
  "wootric-nps": "static-1.7175",
  "quartz-head": "static-1.1064",
  "web-vitals": "static-1.11",
  "apollo-link-hub-http": "static-2.4918",
  "immer": "static-1.94",
  "immerable": "static-1.4413",
  "highcharts": "static-8.108",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2655",
  "reporting-data": "static-1.68659",
  "cssUtils": "static-1.880",
  "flux-actions": "static-1.362",
  "HubStyle": "static-2.12053",
  "PatternValidationJS": "static-1.3159",
  "react-colorpicker": "static-2.10470",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.72",
  "ReduxMessenger": "static-2.10631",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7609",
  "icons": "static-2.675",
  "marketplace-ui-apps-core": "static-1.19168",
  "storybook-react": "static-1.37",
  "trellis-story-utils": "static-1.4773",
  "foundations-components-test-utils": "static-1.5905",
  "quartz-i18n": "static-1.1074",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.384",
  "ads-unified-auth-lib": "static-1.1160",
  "google-sheets-integration-lib": "static-1.960",
  "microsoft-drive-auth-lib": "static-1.56",
  "surveymonkey-integration-lib": "static-1.402",
  "slack-ui-library": "static-1.10661",
  "fsm": "static-1.4004",
  "customer-data-objects": "static-1.7949",
  "property-translator": "static-1.5660",
  "hs-locale-management": "static-1.268",
  "frontend-preferences-client": "static-1.8188",
  "hs-promise-utils": "static-1.5857",
  "hubspot-apollo-client": "static-1.5141",
  "integrations-error-boundary-lib": "static-1.14375",
  "integrations-tracking-lib": "static-1.5870",
  "native-integrations-shared-strings": "static-1.8040",
  "sanitize": "static-1.4738",
  "superstore": "static-1.5019",
  "ui-shepherd-react": "static-3.10528",
  "ai-settings-ui-library": "static-1.8274",
  "hub-http-janus": "static-1.871",
  "hubspotter-http": "static-1.4838",
  "immutable-less": "static-1.4913",
  "marketplace-ui-client-types": "static-1.18043",
  "nav-meta": "static-1.30378",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18335",
  "ui-product-approvals-common": "static-1.921",
  "ai-studio-lib": "static-1.12386",
  "hubspot-prosemirror": "static-1.18899",
  "integrations-reconnect-lib": "static-1.430",
  "ui-addon-iframeable": "static-1.9336",
  "ui-addon-integrations-directory-panel": "static-2.8288",
  "ui-product-approvals": "static-1.29026",
  "ui-tool-access": "static-1.10415",
  "inbound-db-properties-service-client": "static-1.4032",
  "property-management-common": "static-1.6333",
  "opentelemetry-fe-types": "static-1.32",
  "dispatcher": "static-1.142",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.571",
  "module-federation": "static-1.30",
  "opentelemetry-fe": "static-1.407",
  "quartz-auth": "static-1.1074",
  "quartz-test": "static-1.1074",
  "quartz-tracking": "static-1.778",
  "trellis-components": "static-1.2546",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.335",
  "bender-build-tools": "static-1.3397",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.22733",
  "ContentUtils": "static-1.69063",
  "customer-data-objects-ui-components": "static-1.13291",
  "sassPrefix": "static-1.163",
  "diff-match-patch": "static-1.7",
  "bend-plugin-pulse": "static-1.390",
  "batch-promise": "static-1.1804",
  "event-emitter": "static-1.1216",
  "fast-json-patch": "static-1.67",
  "browser-eslint": "static-2.57",
  "magpie-lib": "static-1.5728",
  "magpie-types": "static-1.5188",
  "avatar-components": "static-1.2757",
  "breeze-engine-core": "static-1.891",
  "breeze-onboarding-components": "static-1.647",
  "customer-data-filters-ui": "static-1.40800",
  "customer-data-reference-ui-components": "static-1.13442",
  "embedded-academy-lib": "static-1.15407",
  "ExportDialog": "static-6.10641",
  "highlight.js": "static-1.83",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.41944",
  "reporting-snowflake": "static-1.57276",
  "reporting-ui-components": "static-2.65929",
  "reporting-visualizations": "static-1.60734",
  "trial-components-library": "static-1.14046",
  "trellis-theming": "static-1.1229",
  "ui-addon-teams": "static-1.21870",
  "upgrade-components-lib": "static-1.471",
  "navigation-components": "static-1.18741",
  "breeze-engine-lib": "static-1.1613",
  "simple-logging-lib": "static-1.3313",
  "fail-safe": "static-1.215",
  "app-governance-lib": "static-1.2323",
  "developer-experience-shared-components": "static-1.10766",
  "purchase-motions-components": "static-1.6301",
  "transmute": "static-2.85",
  "usage-based-billing-components-lib": "static-1.10092",
  "usage-tracker-anonymous": "static-1.6036",
  "usage-tracker-public": "static-1.7430",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3718",
  "persist-promise": "static-1.3961",
  "reference-resolvers": "static-1.8442",
  "ui-extensibility-client-types": "static-1.4182",
  "hubspot-apollo-cache": "static-1.600",
  "universal-page-editor-lib": "static-1.3270",
  "final-form": "static-1.75",
  "redux-toolkit": "static-1.75",
  "simple-data-table": "static-1.3464",
  "atom": "static-1.5348",
  "merchandise-lib": "static-1.275",
  "salesImages": "static-1.532",
  "ui-addon-draggable": "static-3.5018",
  "content-assistance-lib": "static-1.8151",
  "content-media-capture": "static-1.5353",
  "customer-data-ui-utilities": "static-1.10090",
  "emoji-mart": "static-3.4",
  "file-manager-components": "static-1.24399",
  "growth-payments-core": "static-1.26106",
  "knowledge-content-types": "static-1.8629",
  "payment-link-components": "static-1.24099",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20254",
  "ui-addon-emoji-picker": "static-1.10148",
  "ui-business-units-lib": "static-1.9346",
  "video-components-external": "static-1.12087",
  "video-data-lib": "static-1.35745",
  "navigation-messaging": "static-1.8068",
  "collaboration-sidebar": "static-1.58643",
  "react-dnd-compat": "static-1.4878",
  "crm-component-utils": "static-1.39763",
  "crm-properties-common-lib": "static-1.6152",
  "customer-data-properties": "static-1.52475",
  "external-options-client-types": "static-1.4315",
  "framework-data-schema-resolvers": "static-1.7155",
  "property-value-citations": "static-1.3089",
  "reference-resolvers-lite": "static-1.8363",
  "opentelemetry-web": "static-1.11",
  "hubspotter-http-shared-msw-handlers": "static-1.10550",
  "base-ui": "static-1.19",
  "react-day-picker": "static-1.7",
  "tanstack-virtual": "static-1.36",
  "cms-field-types": "static-1.5077",
  "content-icons-ui": "static-1.2326",
  "idb-keyval": "static-1.48",
  "reactive-lib": "static-1.983",
  "breeze-artifacts-sdk": "static-1.227",
  "onboarding-journeys-lib": "static-1.830",
  "conversations-skeleton-state": "static-1.7512",
  "crm-message-bus": "static-1.43675",
  "customer-data-filters-ui-msw-helpers": "static-1.23235",
  "events-data-lib": "static-1.503",
  "FormUrlGenerator": "static-2.4990",
  "framework-builder-read-service-client": "static-1.4197",
  "hs-resources": "static-1.454",
  "multi-account-reference-resolvers": "static-1.1261",
  "onboarding-scopes": "static-1.6717",
  "onboarding-tours": "static-1.17063",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14395",
  "academy-common-lib": "static-1.14867",
  "dashboard-lib": "static-1.82689",
  "getting-started-shared-tasks": "static-1.19150",
  "hubspot-prosemirror-plugins": "static-1.18891",
  "share-with-third-party-component-lib": "static-1.8968",
  "ui-asset-management-lib": "static-1.11358",
  "user-context": "static-1.5380",
  "reporting-plugins": "static-1.10687",
  "reporting-reports": "static-1.68336",
  "hubs-service-types": "static-1.1521",
  "purchase-motions-api": "static-1.6304",
  "signup-constants": "static-1.19539",
  "nest": "static-1.498",
  "breeze-engine-chat-components": "static-1.591",
  "ably": "static-2.2",
  "bend-plugin-fail-safe": "static-1.166",
  "framework-listing-lib": "static-2.29414",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31364",
  "apps-service-types": "static-1.4003",
  "oauth-service-types": "static-1.4507",
  "signup-ui-url-generator": "static-2.8322",
  "onboarding-tours-client": "static-1.5277",
  "one-click-checkout": "static-1.324",
  "platform-infra-nav-components": "static-1.7865",
  "subscription-experience-data-types": "static-1.15215",
  "crm-record-cards-service-types": "static-1.3759",
  "location-customization-utils-lib": "static-1.10022",
  "redux-thunk": "static-2.77",
  "react-flip-move": "static-1.75",
  "ui-coaching-tips": "static-1.29243",
  "content-media-composition-data-lib": "static-1.13157",
  "fix-webm-duration": "static-1.27",
  "notification-sounds": "static-1.4689",
  "react-immutable-render-mixin": "static-1.9",
  "seat-types-lib": "static-1.658",
  "ui-addon-opt": "static-4.8629",
  "commerce-tours-lib": "static-1.6557",
  "growth-onboarding-reliability": "static-1.5343",
  "sales-checkout-service-client": "static-1.3790",
  "data-token-picker": "static-1.16836",
  "FileManagerLib": "static-1.40039",
  "content-media-compositions": "static-2.17164",
  "media-bridge-lib": "static-1.19355",
  "chatspot-widget-iframe": "static-1.22724",
  "collaboration-sidebar-common": "static-1.3440",
  "marketing-platform-lib": "static-1.7130",
  "card-properties-lib": "static-1.44935",
  "commerce-subscription-lib": "static-1.37708",
  "crm-actions": "static-1.6612",
  "crm-cards-sdk": "static-1.44440",
  "customer-data-properties-shared-msw-handlers": "static-1.9879",
  "customer-data-tracking": "static-1.7143",
  "calling-global-api": "static-1.65446",
  "calling-internal-common": "static-1.31580",
  "calling-lifecycle-internal": "static-1.66828",
  "calling-lifecycle-messages": "static-1.59122",
  "commerce-products-lib": "static-1.10447",
  "conditional-properties-service-client": "static-1.3987",
  "crm-index-visualization-core": "static-1.4493",
  "crm-links": "static-1.6589",
  "crm-pipelines-api-client-types": "static-1.4323",
  "formula-editor": "static-1.14695",
  "google-libphonenumber": "static-1.42",
  "inbounddb-objects-service-types": "static-1.4400",
  "meetings-icalendar-utils-lib": "static-1.898",
  "multi-currency-client-types": "static-1.3884",
  "object-builder-ui-client": "static-1.49579",
  "pipeline-validation-client-types": "static-1.4157",
  "smart-data-capture-core": "static-1.57",
  "smart-property-lib": "static-1.8206",
  "tiered-pricing": "static-1.1895",
  "topics-actions-lib": "static-1.428",
  "ui-addon-form-validation": "static-1.11248",
  "zustand": "static-1.79",
  "fdsr-migration-layer": "static-1.274",
  "framework-data-schema-quick-fetch": "static-1.7060",
  "restore-request-side-panel-lib": "static-1.1593",
  "growth-data-modal": "static-1.5840",
  "growth-onboarding-confetti": "static-1.3325",
  "growth-onboarding-next-action-utils": "static-1.2625",
  "onboarding-tours-utils": "static-1.1129",
  "ui-shepherd-tracker": "static-1.7909",
  "academy-service-client": "static-1.3951",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39898",
  "SafeStorage": "static-1.4667",
  "video-embed": "static-1.36579",
  "redux-actions": "static-3.68",
  "EmailSignatureEditor": "static-1.24939",
  "viral-links-lib": "static-1.7336",
  "nested-table": "static-1.497",
  "timezone-utils": "static-2.5509",
  "getting-started-shared-tasks-store": "static-1.18268",
  "campaign-roi-lib": "static-1.10037",
  "ui-addon-calendars": "static-2.5590",
  "customer-data-views-management": "static-1.25959",
  "framework-data-table": "static-2.12483",
  "nudge-client-utils": "static-1.3091",
  "nudge-custom-ui-functions": "static-1.1438",
  "switchboard-lib": "static-1.478",
  "access-check-ui-lib": "static-1.1513",
  "app-users-service-client": "static-1.5882",
  "app-users-service-types": "static-1.5290",
  "mini-checkout-client": "static-1.27419",
  "onboarding-utils": "static-1.5626",
  "permissions-shared-i18n-strings-fe": "static-1.2119",
  "ui-coaching-tips-shared-config": "static-1.29228",
  "checkout-sdk": "static-3.24262",
  "payment-method-components": "static-1.7109",
  "touchless-buying-components": "static-1.6130",
  "upgrade-catalog-service-types": "static-1.3745",
  "edison-service-client-types": "static-1.655",
  "growth-onboarding-feedback-components": "static-1.6846",
  "audio-components": "static-1.6291",
  "FileManagerImages": "static-1.37550",
  "video-components": "static-1.14089",
  "js-cookie": "static-1.18",
  "crm_data": "static-4.92751",
  "customer-data-sidebar": "static-2.46670",
  "enrichment-lib": "static-1.210",
  "ui-addon-draggable-compat": "static-2.4526",
  "universal-record-utils-lib": "static-1.1779",
  "commerce-billing-lib": "static-1.20054",
  "commerce-shared-components-lib": "static-1.19154",
  "commerce-tools-ui-lib": "static-1.10981",
  "crm-fe-perf": "static-1.23164",
  "calling-error-reporting": "static-1.31587",
  "shared-worker-versioning": "static-1.11302",
  "calling-usage-tracker": "static-1.6800",
  "voice-sms-access-library": "static-1.1948",
  "commerce-permissions": "static-1.1039",
  "products-iframe-lib": "static-1.8522",
  "products-ui-components-shared-msw-handlers": "static-1.10934",
  "crm-index-associations-lib": "static-1.6705",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10635",
  "sales-views-client-types": "static-1.4518",
  "bark-lib": "static-1.16769",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.593",
  "policy-lib": "static-1.7059",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10698",
  "onboarding-data-sync-lib": "static-1.2440",
  "growth-onboarding-next-action-components": "static-1.2653",
  "user-context-client": "static-1.4771",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.58",
  "urlinator": "static-1.4795",
  "outpost": "static-1.4422",
  "draft-convert": "static-2.77",
  "draft-extend": "static-3.80",
  "draft-js": "static-5.82",
  "draft-plugins": "static-2.22105",
  "sales-email-signature-service-client": "static-1.4108",
  "ts-utils-lib": "static-1.426",
  "crm-export-dialog": "static-1.6546",
  "crm-view-components": "static-1.1026",
  "react-beautiful-dnd": "static-1.67",
  "customer-data-associations": "static-1.7589",
  "tasks-actions-lib": "static-1.51",
  "nudge-custom-function-registry": "static-1.2848",
  "nudge-renderer-utils": "static-1.3167",
  "whisper-core-api": "static-1.7259",
  "InboxConnectUtils": "static-4.15485",
  "emoji-regex": "static-1.7",
  "settings-content-modals": "static-1.46775",
  "hub-http-rxjs": "static-1.835",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4253",
  "company-details-components": "static-1.6463",
  "react-performance-metrics-lib": "static-1.819",
  "pricing-pages-ui-components": "static-1.15586",
  "quote-checkout-service-types": "static-1.3721",
  "social-insights-client-types": "static-1.22685",
  "crm_universal": "static-1.22446",
  "customer-data-email": "static-1.18473",
  "card-payment-highlight-lib": "static-1.37902",
  "card-subscription-highlight-lib": "static-1.40131",
  "commerce-contract-lib": "static-1.13210",
  "invoices-highlight-card-lib": "static-1.55598",
  "orders-highlight-card-lib": "static-1.22119",
  "products-highlight-card-lib": "static-1.18730",
  "quotes-highlight-card-lib": "static-1.72763",
  "crm-source-interpretation-lib": "static-1.5595",
  "data-agent-utils": "static-1.272",
  "crm-object-search-query-utilities": "static-1.10138",
  "utility-belt": "static-1.2794",
  "payments-enrollment-embed-lib": "static-1.23732",
  "stripe-embedded-components": "static-1.7944",
  "customer-data-rte": "static-1.33583",
  "cv-backend-services": "static-1.1590",
  "growth-onboarding-empty-states": "static-1.6213",
  "payments-post-enroll-local-storage-lib": "static-1.5369",
  "qrcode-generator": "static-1.73",
  "quotes-client-types": "static-1.38853",
  "calling-orchestration-schema": "static-1.36725",
  "react-reducer-toolkit": "static-1.16294",
  "meetings-connect-utils-lib": "static-1.7872",
  "hub-http-contrib": "static-1.3300",
  "ui-addon-sales-email": "static-1.5477",
  "access-control-lib": "static-1.10699",
  "EmailComponents": "static-1.55479",
  "EmailData": "static-1.54157",
  "redux-less": "static-2.9741",
  "company-details-service-types": "static-1.4202",
  "segments-query-core": "static-1.1686",
  "pricing-pages-api": "static-1.15451",
  "sequences-lib": "static-1.8485",
  "ui-gdpr-components": "static-1.10619",
  "products-ui-components": "static-1.40965",
  "accounting-integrations-ui-components": "static-1.7487",
  "invoices-ui-lib": "static-1.55614",
  "commerce-products-api": "static-1.2651",
  "invoices-iframe-lib": "static-1.57672",
  "quotes-modal-lib": "static-1.103441",
  "quotes-ui-lib": "static-1.81484",
  "stripe-connect-js": "static-1.75",
  "draft-content-plugins": "static-1.28847",
  "ContentComponents": "static-2.72019",
  "ContentData": "static-1.69138",
  "marketing-contacts-lib": "static-1.10941",
  "marketing-email-service-types": "static-1.2074",
  "messaging-editing-lib": "static-1.47061",
  "messaging-usage-based-billing-components-lib": "static-1.1923",
  "automation-ui-source-apps": "static-1.19602",
  "automation-ui-types": "static-1.20520",
  "messaging-types-lib": "static-1.46798",
  "onboarding-settings-client": "static-1.4771",
  "sequences-client-types-lib": "static-1.8342",
  "commerce-tax-lib": "static-1.800",
  "price-books-api": "static-1.1664",
  "price-books-components": "static-1.1722",
  "property-description-translator": "static-1.4103",
  "ramp-editor": "static-1.829",
  "commerce-analytics-service-client": "static-1.3778",
  "totals-ui-components": "static-1.24228",
  "SalesContentIndexUI": "static-3.9583",
  "advanced-menus-core": "static-1.15527",
  "advanced-menus-lib": "static-1.12406",
  "automation-ui-ubb": "static-1.6436",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7599",
  "data-token-views": "static-1.16817",
  "forms-utils-lib": "static-1.13041",
  "payments-embed-points-lib": "static-1.13533",
  "react-tinymce": "static-1.55906",
  "simple-menus-core": "static-1.15526",
  "simple-menus-lib": "static-1.17043",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.55032",
  "tinymce-data": "static-1.41117",
  "tinymce-plugins": "static-1.58146",
  "tinymce-themes": "static-1.57002",
  "ui-brand-identity-lib": "static-1.16310",
  "ui-memberships-settings-lib": "static-1.34772",
  "videoconference-integration-components": "static-1.7195",
  "marketing-contacts-client": "static-1.7772",
  "mc-hard-limits-client-types": "static-1.166",
  "automation-applications-service-types": "static-1.3648",
  "automation-platform-service-types": "static-1.2659",
  "ContentEditorUI": "static-2.77832",
  "short-messages-app-service-client": "static-1.4179",
  "web-interactives-components": "static-1.14196",
  "web-interactives-data": "static-1.14197",
  "messaging-shared-utils-lib": "static-1.1372",
  "messaging-user-info-utils-lib": "static-1.1542",
  "email-portal-health-service-types": "static-1.1241",
  "line-items-api": "static-1.1050",
  "commerce-totals-service-types": "static-1.4006",
  "FireAlarmUi": "static-1.4694",
  "sales-templates-service-types-lib": "static-1.4359",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22456",
  "automation-ui-usage-tracking": "static-1.21919",
  "data-studio-ubb": "static-1.3439",
  "interframe": "static-3.5018",
  "layout-dnd-components": "static-1.12910",
  "layout-dnd-utils": "static-1.11885",
  "NamespacedHubStyle": "static-2.9237",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27589",
  "content-management-data-lib": "static-1.5899",
  "copilot-plugins": "static-1.11748",
  "cta-picker": "static-1.37020",
  "customer-agent-discovery-components-lib": "static-1.3810",
  "editor-components": "static-1.13599",
  "editor-iframe-lib": "static-1.8750",
  "error-messaging-js": "static-1.5459",
  "FormsCommonComponents": "static-1.86493",
  "layout-data-lib": "static-1.10210",
  "pictos": "static-7.190",
  "react-transition-group": "static-2.69",
  "redux-request-state": "static-1.10912",
  "SharedLegalStrings": "static-1.2010",
  "smart-content-core": "static-1.43105",
  "smart-content-lib": "static-1.43758",
  "social-composer-lib": "static-1.60144",
  "structured-content-lib": "static-1.25853",
  "theme-previewer-lib": "static-1.53878",
  "tinymce-copilot": "static-1.17100",
  "xray-recommendation-lib": "static-1.8220",
  "automation-ui-routing": "static-1.21877",
  "sql-reporting-client-types": "static-1.5859",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42722",
  "campaigns-utils-lib": "static-1.3465",
  "reporting-enablement": "static-1.23752",
  "forms-ai-lib": "static-1.4712",
  "codemirror-dlb": "static-1.59391",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6701",
  "report-customization-components": "static-1.13836",
  "data-quality-ui-library": "static-1.13717",
  "reporting-filters": "static-1.939",
  "reporting-insights-lib": "static-1.2495"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13156",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "breeze-builder-lib": "/breeze-builder-lib/static-1.653",
  "client-types": "/client-types/static-1.494",
  "data-fetching-client": "/data-fetching-client/static-1.9920",
  "foundations-components": "/foundations-components/static-1.8422",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1447",
  "foundations-theming": "/foundations-theming/static-1.4730",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.86",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8291",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10552",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "HubStyleTokens": "/HubStyleTokens/static-2.11746",
  "I18n": "/I18n/static-7.1665",
  "jasmine-runner": "/jasmine-runner/static-1.6715",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.575",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13219",
  "quartz": "/quartz/static-1.7399",
  "react-dlb": "/react-dlb/static-1.87",
  "react-rhumb": "/react-rhumb/static-1.16974",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3118",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10592",
  "reselect": "/reselect/static-3.9",
  "settings-ui-lib": "/settings-ui-lib/static-1.12783",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7580",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11406",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9800",
  "unified-auth": "/unified-auth/static-1.836",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1118",
  "usage-tracker": "/usage-tracker/static-1.7619",
  "usage-tracker-core": "/usage-tracker-core/static-1.7469",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8361",
  "hub-http": "/hub-http/static-1.6476",
  "integrations-lib": "/integrations-lib/static-1.16960",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20636",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.622",
  "property-management-iframe": "/property-management-iframe/static-1.14045",
  "quartz-config": "/quartz-config/static-1.1177",
  "quartz-core": "/quartz-core/static-1.6618",
  "quartz-routing": "/quartz-routing/static-1.829",
  "quick-fetch": "/quick-fetch/static-1.4106",
  "react": "/react/static-7.191",
  "rpc-client-utils": "/rpc-client-utils/static-1.4925",
  "ts-schema": "/ts-schema/static-1.4269",
  "ui-universal-auth": "/ui-universal-auth/static-1.9322",
  "UIComponents": "/UIComponents/static-3.8692",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.83",
  "metrics-js": "/metrics-js/static-1.9867",
  "react-redux": "/react-redux/static-7.75",
  "redux": "/redux/static-4.76",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3591",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3676",
  "quartz-webpack": "/quartz-webpack/static-1.3623",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.477",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9630",
  "codemirror": "/codemirror/static-5.99",
  "foundations-assets": "/foundations-assets/static-1.5146",
  "pulse": "/pulse/static-1.887",
  "react-codemirror": "/react-codemirror/static-1.10901",
  "ui-extensions-preview-lib": "/ui-extensions-preview-lib/static-1.521",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4691",
  "floating-ui": "/floating-ui/static-1.62",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2446",
  "framer-motion": "/framer-motion/static-1.76",
  "hs-story-utils": "/hs-story-utils/static-1.9689",
  "react-aria": "/react-aria/static-1.70",
  "react-create-root-preference": "/react-create-root-preference/static-1.64",
  "react-select-plus": "/react-select-plus/static-1.109",
  "react-utils": "/react-utils/static-2.5529",
  "react-virtualized": "/react-virtualized/static-2.104",
  "StyleGuideUI": "/StyleGuideUI/static-3.497",
  "tanstack-table": "/tanstack-table/static-1.59",
  "trellis-assets": "/trellis-assets/static-1.2527",
  "ui-fonts": "/ui-fonts/static-1.1008",
  "ui-images": "/ui-images/static-2.1234",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3213",
  "foundations-theming-base": "/foundations-theming-base/static-1.3715",
  "stylex": "/stylex/static-1.38",
  "HeadJS": "/HeadJS/static-2.791",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3402",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.156",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.228",
  "moment-timezone": "/moment-timezone/static-5.87",
  "jasmine": "/jasmine/static-4.4578",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8965",
  "ai-rendering-library": "/ai-rendering-library/static-1.11030",
  "chirp-fetch": "/chirp-fetch/static-1.2156",
  "connections-embed-lib": "/connections-embed-lib/static-1.1457",
  "copilot-toolkit": "/copilot-toolkit/static-1.11776",
  "feedback-loader": "/feedback-loader/static-1.29755",
  "laboratory-lib": "/laboratory-lib/static-3.7414",
  "marketplace-embed": "/marketplace-embed/static-1.22846",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10531",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20591",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14806",
  "sanitize-text": "/sanitize-text/static-1.8414",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6033",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5305",
  "wootric-nps": "/wootric-nps/static-1.7175",
  "quartz-head": "/quartz-head/static-1.1064",
  "web-vitals": "/web-vitals/static-1.11",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4918",
  "immer": "/immer/static-1.94",
  "immerable": "/immerable/static-1.4413",
  "highcharts": "/highcharts/static-8.108",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2655",
  "reporting-data": "/reporting-data/static-1.68659",
  "cssUtils": "/cssUtils/static-1.880",
  "flux-actions": "/flux-actions/static-1.362",
  "HubStyle": "/HubStyle/static-2.12053",
  "PatternValidationJS": "/PatternValidationJS/static-1.3159",
  "react-colorpicker": "/react-colorpicker/static-2.10470",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.72",
  "ReduxMessenger": "/ReduxMessenger/static-2.10631",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7609",
  "icons": "/icons/static-2.675",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19168",
  "storybook-react": "/storybook-react/static-1.37",
  "trellis-story-utils": "/trellis-story-utils/static-1.4773",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5905",
  "quartz-i18n": "/quartz-i18n/static-1.1074",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.384",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1160",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.960",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.56",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.402",
  "slack-ui-library": "/slack-ui-library/static-1.10661",
  "fsm": "/fsm/static-1.4004",
  "customer-data-objects": "/customer-data-objects/static-1.7949",
  "property-translator": "/property-translator/static-1.5660",
  "hs-locale-management": "/hs-locale-management/static-1.268",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8188",
  "hs-promise-utils": "/hs-promise-utils/static-1.5857",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5141",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14375",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5870",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8040",
  "sanitize": "/sanitize/static-1.4738",
  "superstore": "/superstore/static-1.5019",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10528",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8274",
  "hub-http-janus": "/hub-http-janus/static-1.871",
  "hubspotter-http": "/hubspotter-http/static-1.4838",
  "immutable-less": "/immutable-less/static-1.4913",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18043",
  "nav-meta": "/nav-meta/static-1.30378",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18335",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.921",
  "ai-studio-lib": "/ai-studio-lib/static-1.12386",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18899",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.430",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9336",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8288",
  "ui-product-approvals": "/ui-product-approvals/static-1.29026",
  "ui-tool-access": "/ui-tool-access/static-1.10415",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4032",
  "property-management-common": "/property-management-common/static-1.6333",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.32",
  "dispatcher": "/dispatcher/static-1.142",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.571",
  "module-federation": "/module-federation/static-1.30",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.407",
  "quartz-auth": "/quartz-auth/static-1.1074",
  "quartz-test": "/quartz-test/static-1.1074",
  "quartz-tracking": "/quartz-tracking/static-1.778",
  "trellis-components": "/trellis-components/static-1.2546",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.335",
  "bender-build-tools": "/bender-build-tools/static-1.3397",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.22733",
  "ContentUtils": "/ContentUtils/static-1.69063",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13291",
  "sassPrefix": "/sassPrefix/static-1.163",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.390",
  "batch-promise": "/batch-promise/static-1.1804",
  "event-emitter": "/event-emitter/static-1.1216",
  "fast-json-patch": "/fast-json-patch/static-1.67",
  "browser-eslint": "/browser-eslint/static-2.57",
  "magpie-lib": "/magpie-lib/static-1.5728",
  "magpie-types": "/magpie-types/static-1.5188",
  "avatar-components": "/avatar-components/static-1.2757",
  "breeze-engine-core": "/breeze-engine-core/static-1.891",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.647",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40800",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13442",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15407",
  "ExportDialog": "/ExportDialog/static-6.10641",
  "highlight.js": "/highlight.js/static-1.83",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.41944",
  "reporting-snowflake": "/reporting-snowflake/static-1.57276",
  "reporting-ui-components": "/reporting-ui-components/static-2.65929",
  "reporting-visualizations": "/reporting-visualizations/static-1.60734",
  "trial-components-library": "/trial-components-library/static-1.14046",
  "trellis-theming": "/trellis-theming/static-1.1229",
  "ui-addon-teams": "/ui-addon-teams/static-1.21870",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.471",
  "navigation-components": "/navigation-components/static-1.18741",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1613",
  "simple-logging-lib": "/simple-logging-lib/static-1.3313",
  "fail-safe": "/fail-safe/static-1.215",
  "app-governance-lib": "/app-governance-lib/static-1.2323",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10766",
  "purchase-motions-components": "/purchase-motions-components/static-1.6301",
  "transmute": "/transmute/static-2.85",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10092",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6036",
  "usage-tracker-public": "/usage-tracker-public/static-1.7430",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "persist-promise": "/persist-promise/static-1.3961",
  "reference-resolvers": "/reference-resolvers/static-1.8442",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4182",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.600",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3270",
  "final-form": "/final-form/static-1.75",
  "redux-toolkit": "/redux-toolkit/static-1.75",
  "simple-data-table": "/simple-data-table/static-1.3464",
  "atom": "/atom/static-1.5348",
  "merchandise-lib": "/merchandise-lib/static-1.275",
  "salesImages": "/salesImages/static-1.532",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5018",
  "content-assistance-lib": "/content-assistance-lib/static-1.8151",
  "content-media-capture": "/content-media-capture/static-1.5353",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10090",
  "emoji-mart": "/emoji-mart/static-3.4",
  "file-manager-components": "/file-manager-components/static-1.24399",
  "growth-payments-core": "/growth-payments-core/static-1.26106",
  "knowledge-content-types": "/knowledge-content-types/static-1.8629",
  "payment-link-components": "/payment-link-components/static-1.24099",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20254",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10148",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9346",
  "video-components-external": "/video-components-external/static-1.12087",
  "video-data-lib": "/video-data-lib/static-1.35745",
  "navigation-messaging": "/navigation-messaging/static-1.8068",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58643",
  "react-dnd-compat": "/react-dnd-compat/static-1.4878",
  "crm-component-utils": "/crm-component-utils/static-1.39763",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6152",
  "customer-data-properties": "/customer-data-properties/static-1.52475",
  "external-options-client-types": "/external-options-client-types/static-1.4315",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7155",
  "property-value-citations": "/property-value-citations/static-1.3089",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8363",
  "opentelemetry-web": "/opentelemetry-web/static-1.11",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10550",
  "base-ui": "/base-ui/static-1.19",
  "react-day-picker": "/react-day-picker/static-1.7",
  "tanstack-virtual": "/tanstack-virtual/static-1.36",
  "cms-field-types": "/cms-field-types/static-1.5077",
  "content-icons-ui": "/content-icons-ui/static-1.2326",
  "idb-keyval": "/idb-keyval/static-1.48",
  "reactive-lib": "/reactive-lib/static-1.983",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.227",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.830",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7512",
  "crm-message-bus": "/crm-message-bus/static-1.43675",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23235",
  "events-data-lib": "/events-data-lib/static-1.503",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4990",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4197",
  "hs-resources": "/hs-resources/static-1.454",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1261",
  "onboarding-scopes": "/onboarding-scopes/static-1.6717",
  "onboarding-tours": "/onboarding-tours/static-1.17063",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14395",
  "academy-common-lib": "/academy-common-lib/static-1.14867",
  "dashboard-lib": "/dashboard-lib/static-1.82689",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19150",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18891",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8968",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11358",
  "user-context": "/user-context/static-1.5380",
  "reporting-plugins": "/reporting-plugins/static-1.10687",
  "reporting-reports": "/reporting-reports/static-1.68336",
  "hubs-service-types": "/hubs-service-types/static-1.1521",
  "purchase-motions-api": "/purchase-motions-api/static-1.6304",
  "signup-constants": "/signup-constants/static-1.19539",
  "nest": "/nest/static-1.498",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.591",
  "ably": "/ably/static-2.2",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.166",
  "framework-listing-lib": "/framework-listing-lib/static-2.29414",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31364",
  "apps-service-types": "/apps-service-types/static-1.4003",
  "oauth-service-types": "/oauth-service-types/static-1.4507",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8322",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5277",
  "one-click-checkout": "/one-click-checkout/static-1.324",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7865",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15215",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3759",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10022",
  "redux-thunk": "/redux-thunk/static-2.77",
  "react-flip-move": "/react-flip-move/static-1.75",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29243",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13157",
  "fix-webm-duration": "/fix-webm-duration/static-1.27",
  "notification-sounds": "/notification-sounds/static-1.4689",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "seat-types-lib": "/seat-types-lib/static-1.658",
  "ui-addon-opt": "/ui-addon-opt/static-4.8629",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6557",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5343",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3790",
  "data-token-picker": "/data-token-picker/static-1.16836",
  "FileManagerLib": "/FileManagerLib/static-1.40039",
  "content-media-compositions": "/content-media-compositions/static-2.17164",
  "media-bridge-lib": "/media-bridge-lib/static-1.19355",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.22724",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3440",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7130",
  "card-properties-lib": "/card-properties-lib/static-1.44935",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37708",
  "crm-actions": "/crm-actions/static-1.6612",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.44440",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9879",
  "customer-data-tracking": "/customer-data-tracking/static-1.7143",
  "calling-global-api": "/calling-global-api/static-1.65446",
  "calling-internal-common": "/calling-internal-common/static-1.31580",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66828",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59122",
  "commerce-products-lib": "/commerce-products-lib/static-1.10447",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3987",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4493",
  "crm-links": "/crm-links/static-1.6589",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4323",
  "formula-editor": "/formula-editor/static-1.14695",
  "google-libphonenumber": "/google-libphonenumber/static-1.42",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4400",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.898",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3884",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49579",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4157",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.57",
  "smart-property-lib": "/smart-property-lib/static-1.8206",
  "tiered-pricing": "/tiered-pricing/static-1.1895",
  "topics-actions-lib": "/topics-actions-lib/static-1.428",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11248",
  "zustand": "/zustand/static-1.79",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.274",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7060",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1593",
  "growth-data-modal": "/growth-data-modal/static-1.5840",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3325",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2625",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1129",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7909",
  "academy-service-client": "/academy-service-client/static-1.3951",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39898",
  "SafeStorage": "/SafeStorage/static-1.4667",
  "video-embed": "/video-embed/static-1.36579",
  "redux-actions": "/redux-actions/static-3.68",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24939",
  "viral-links-lib": "/viral-links-lib/static-1.7336",
  "nested-table": "/nested-table/static-1.497",
  "timezone-utils": "/timezone-utils/static-2.5509",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18268",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.10037",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5590",
  "customer-data-views-management": "/customer-data-views-management/static-1.25959",
  "framework-data-table": "/framework-data-table/static-2.12483",
  "nudge-client-utils": "/nudge-client-utils/static-1.3091",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1438",
  "switchboard-lib": "/switchboard-lib/static-1.478",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.1513",
  "app-users-service-client": "/app-users-service-client/static-1.5882",
  "app-users-service-types": "/app-users-service-types/static-1.5290",
  "mini-checkout-client": "/mini-checkout-client/static-1.27419",
  "onboarding-utils": "/onboarding-utils/static-1.5626",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2119",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29228",
  "checkout-sdk": "/checkout-sdk/static-3.24262",
  "payment-method-components": "/payment-method-components/static-1.7109",
  "touchless-buying-components": "/touchless-buying-components/static-1.6130",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3745",
  "edison-service-client-types": "/edison-service-client-types/static-1.655",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6846",
  "audio-components": "/audio-components/static-1.6291",
  "FileManagerImages": "/FileManagerImages/static-1.37550",
  "video-components": "/video-components/static-1.14089",
  "js-cookie": "/js-cookie/static-1.18",
  "crm_data": "/crm_data/static-4.92751",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46670",
  "enrichment-lib": "/enrichment-lib/static-1.210",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4526",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1779",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20054",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19154",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10981",
  "crm-fe-perf": "/crm-fe-perf/static-1.23164",
  "calling-error-reporting": "/calling-error-reporting/static-1.31587",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11302",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6800",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1948",
  "commerce-permissions": "/commerce-permissions/static-1.1039",
  "products-iframe-lib": "/products-iframe-lib/static-1.8522",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10934",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6705",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10635",
  "sales-views-client-types": "/sales-views-client-types/static-1.4518",
  "bark-lib": "/bark-lib/static-1.16769",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.593",
  "policy-lib": "/policy-lib/static-1.7059",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10698",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2440",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2653",
  "user-context-client": "/user-context-client/static-1.4771",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.58",
  "urlinator": "/urlinator/static-1.4795",
  "outpost": "/outpost/static-1.4422",
  "draft-convert": "/draft-convert/static-2.77",
  "draft-extend": "/draft-extend/static-3.80",
  "draft-js": "/draft-js/static-5.82",
  "draft-plugins": "/draft-plugins/static-2.22105",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4108",
  "ts-utils-lib": "/ts-utils-lib/static-1.426",
  "crm-export-dialog": "/crm-export-dialog/static-1.6546",
  "crm-view-components": "/crm-view-components/static-1.1026",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.67",
  "customer-data-associations": "/customer-data-associations/static-1.7589",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.51",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2848",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3167",
  "whisper-core-api": "/whisper-core-api/static-1.7259",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15485",
  "emoji-regex": "/emoji-regex/static-1.7",
  "settings-content-modals": "/settings-content-modals/static-1.46775",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.835",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4253",
  "company-details-components": "/company-details-components/static-1.6463",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.819",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.15586",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3721",
  "social-insights-client-types": "/social-insights-client-types/static-1.22685",
  "crm_universal": "/crm_universal/static-1.22446",
  "customer-data-email": "/customer-data-email/static-1.18473",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37902",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.40131",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.13210",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55598",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22119",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18730",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72763",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5595",
  "data-agent-utils": "/data-agent-utils/static-1.272",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10138",
  "utility-belt": "/utility-belt/static-1.2794",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23732",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7944",
  "customer-data-rte": "/customer-data-rte/static-1.33583",
  "cv-backend-services": "/cv-backend-services/static-1.1590",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6213",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5369",
  "qrcode-generator": "/qrcode-generator/static-1.73",
  "quotes-client-types": "/quotes-client-types/static-1.38853",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36725",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16294",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7872",
  "hub-http-contrib": "/hub-http-contrib/static-1.3300",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5477",
  "access-control-lib": "/access-control-lib/static-1.10699",
  "EmailComponents": "/EmailComponents/static-1.55479",
  "EmailData": "/EmailData/static-1.54157",
  "redux-less": "/redux-less/static-2.9741",
  "company-details-service-types": "/company-details-service-types/static-1.4202",
  "segments-query-core": "/segments-query-core/static-1.1686",
  "pricing-pages-api": "/pricing-pages-api/static-1.15451",
  "sequences-lib": "/sequences-lib/static-1.8485",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10619",
  "products-ui-components": "/products-ui-components/static-1.40965",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7487",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55614",
  "commerce-products-api": "/commerce-products-api/static-1.2651",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57672",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103441",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81484",
  "stripe-connect-js": "/stripe-connect-js/static-1.75",
  "draft-content-plugins": "/draft-content-plugins/static-1.28847",
  "ContentComponents": "/ContentComponents/static-2.72019",
  "ContentData": "/ContentData/static-1.69138",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10941",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.2074",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.47061",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1923",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19602",
  "automation-ui-types": "/automation-ui-types/static-1.20520",
  "messaging-types-lib": "/messaging-types-lib/static-1.46798",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4771",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8342",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.800",
  "price-books-api": "/price-books-api/static-1.1664",
  "price-books-components": "/price-books-components/static-1.1722",
  "property-description-translator": "/property-description-translator/static-1.4103",
  "ramp-editor": "/ramp-editor/static-1.829",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3778",
  "totals-ui-components": "/totals-ui-components/static-1.24228",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9583",
  "advanced-menus-core": "/advanced-menus-core/static-1.15527",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12406",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6436",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7599",
  "data-token-views": "/data-token-views/static-1.16817",
  "forms-utils-lib": "/forms-utils-lib/static-1.13041",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13533",
  "react-tinymce": "/react-tinymce/static-1.55906",
  "simple-menus-core": "/simple-menus-core/static-1.15526",
  "simple-menus-lib": "/simple-menus-lib/static-1.17043",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.55032",
  "tinymce-data": "/tinymce-data/static-1.41117",
  "tinymce-plugins": "/tinymce-plugins/static-1.58146",
  "tinymce-themes": "/tinymce-themes/static-1.57002",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16310",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34772",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.7195",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7772",
  "mc-hard-limits-client-types": "/mc-hard-limits-client-types/static-1.166",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3648",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2659",
  "ContentEditorUI": "/ContentEditorUI/static-2.77832",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4179",
  "web-interactives-components": "/web-interactives-components/static-1.14196",
  "web-interactives-data": "/web-interactives-data/static-1.14197",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1372",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1542",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1241",
  "line-items-api": "/line-items-api/static-1.1050",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.4006",
  "FireAlarmUi": "/FireAlarmUi/static-1.4694",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4359",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22456",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21919",
  "data-studio-ubb": "/data-studio-ubb/static-1.3439",
  "interframe": "/interframe/static-3.5018",
  "layout-dnd-components": "/layout-dnd-components/static-1.12910",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11885",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9237",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27589",
  "content-management-data-lib": "/content-management-data-lib/static-1.5899",
  "copilot-plugins": "/copilot-plugins/static-1.11748",
  "cta-picker": "/cta-picker/static-1.37020",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3810",
  "editor-components": "/editor-components/static-1.13599",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8750",
  "error-messaging-js": "/error-messaging-js/static-1.5459",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86493",
  "layout-data-lib": "/layout-data-lib/static-1.10210",
  "pictos": "/pictos/static-7.190",
  "react-transition-group": "/react-transition-group/static-2.69",
  "redux-request-state": "/redux-request-state/static-1.10912",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2010",
  "smart-content-core": "/smart-content-core/static-1.43105",
  "smart-content-lib": "/smart-content-lib/static-1.43758",
  "social-composer-lib": "/social-composer-lib/static-1.60144",
  "structured-content-lib": "/structured-content-lib/static-1.25853",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53878",
  "tinymce-copilot": "/tinymce-copilot/static-1.17100",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8220",
  "automation-ui-routing": "/automation-ui-routing/static-1.21877",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5859",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42722",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3465",
  "reporting-enablement": "/reporting-enablement/static-1.23752",
  "forms-ai-lib": "/forms-ai-lib/static-1.4712",
  "codemirror-dlb": "/codemirror-dlb/static-1.59391",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6701",
  "report-customization-components": "/report-customization-components/static-1.13836",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13717",
  "reporting-filters": "/reporting-filters/static-1.939",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2495"
}
};
